import React, { useContext, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import { MachineContext } from "../../contexts/MachineContext";
import LoadingComponent from "../../components/LoadingComponent";
import MessageComponent from "../../components/MessageComponent";
import ButtonComponent from "../../components/ButtonComponent";
import ButtonsGroupComponent from "../../components/ButtonsGroupComponent";
import { getRequest, postRequest } from "../../utils/requests";
import { gridSizesClassName } from "../../utils/gridSizes";
import { secondsToPrettyTime } from "../../utils/data";

export default function PresetsScreen(props) {
  const { t } = useContext(LocalesContext);
  const [presets, setPresets] = useState(null);
  const [activatingPresetId, setActivatingPresetId] = useState(null);

  const {
    machineParams
  } = useContext(MachineContext);

  useEffect(() => {
    loadPresets();
  }, []);

  const loadPresets = () => {
    getRequest(
      props.apis.presets_index_api,
      {
        apis_auth_token: props.apis.auth_token,
        machine_uuid: props.machine_uuid,
      },
      (response) => {
        if (response.result) setPresets(response.payload.presets);
      }
    );
  };

  const handleActivatePreset = (preset) => {
    setActivatingPresetId(preset.uuid);
    const apiUrl = '/apis/v2/presets/activate-action';
    const apiUrlWithParams = new URL(apiUrl, window.location.origin);
    apiUrlWithParams.searchParams.append('preset_uuid', preset.uuid);
    console.log("Activating preset:", preset.uuid);
    console.log("API URL:", apiUrlWithParams.toString());
    console.log(preset.machine_uuid);
    
    postRequest(
      apiUrlWithParams.toString(),
      {
        preset_uuid: preset.uuid,
      },
      (response) => {
        console.log("Activation response:", response);
        setActivatingPresetId(null);
        
        if (response.result) {
          loadPresets();
        } else {
          alert(response.error || t("application.messages.activation_failed"));
        }
      },
      (error) => {
        console.error("Activation error:", error);
        setActivatingPresetId(null);
        alert(t("application.messages.activation_failed"));
      }
    );
  };

  return (
    <div>
      {presets ? (
        <>
          {presets.length ? (
            <>
              <div className="row row--end row--actions row--mb">
                <ButtonComponent
                  className="c-button"
                  label={t("application.cta.create_preset")}
                  onClick={() => props.goTo("editor", { type: "preset_new" })}
                />
              </div>
              <div className="c-table__responsive">
                <table className="c-table">
                  <thead>
                    <tr>
                      <th>{t("application.labels.name")}</th>
                      <th>
                        {t("NumeroFile")}
                      </th>
                      <th>{t("Interfila")}</th>
                      <th>
                        {t("DistanzaSemina")}
                      </th>
                      <th>
                        {t("Investimento")}
                      </th>
                      <th>
                        {t("Status")}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {presets.map((preset) => {
                      return (
                        <tr key={preset.uuid} className={preset.active ? "c-table__row-active" : ""}>
                          <th>
                            {preset.name}
                          </th>
                          <td>
                            {preset.params.setupFile.length || machineParams.setup?.numeroFile || 24}
                          </td>
                          <td>
                            {preset.params.interfila} cm
                          </td>
                          <td>
                            {preset.params.distanzaSemina} cm
                          </td>
                          <td>
                            {preset.params.investimento} kseed/ha
                          </td>
                          <td>
                            {preset.active ? 
                              <span className="c-badge c-badge--success">{t("Active")}</span> : 
                              <span className="c-badge c-badge--default">{t("Inactive")}</span>
                            }
                          </td>
                          <td className="mobile">
                            <span><p>{t("application.labels.name")}</p><p>{preset.name}</p></span>
                            <span><p>{t("NumeroFile")}</p><p>{preset.params.setupFile.length || machineParams.setup?.numeroFile || 24}</p></span>
                            <span><p>{t("Interfila")}</p><p>{preset.params.interfila} cm</p></span>
                            <span><p>{t("DistanzaSemina")}</p><p>{preset.params.distanzaSemina} cm</p></span>
                            <span><p>{t("Investimento")}</p><p>{preset.params.investimento} kseed/ha</p></span>
                            <span><p>{t("Status")}</p><p>{preset.active ? 
                              <span className="c-badge c-badge--success">{t("Active")}</span> : 
                              <span className="c-badge c-badge--default">{t("Inactive")}</span>
                            }</p></span>
                          </td>
                          <td className="c-table__actions">
                            <div>
                            <ButtonComponent
                              icon="fas fa-edit"
                              className="button-icon"
                              onClick={() =>
                                props.goTo("editor", {
                                  type: "preset_edit",
                                  params: preset.params,
                                  preset,
                                })
                              }
                            />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <MessageComponent
              title={t("application.messages.no_preset")}
              message={t("application.messages.no_preset_description")}
              extraContent={() => (
                <ButtonComponent
                  className="c-button"
                  label={t("application.cta.create_preset")}
                  onClick={() => props.goTo("editor", { type: "preset_new" })}
                />
              )}
            />
          )}
        </>
      ) : (
        <LoadingComponent semifullscreen />
      )}
    </div>
  );
}

PresetsScreen.propTypes = {
  goTo: PropTypes.func,
  machine_uuid: PropTypes.string.isRequired,
  apis: PropTypes.shape({
    auth_token: PropTypes.string.isRequired,
    presets_index_api: PropTypes.string.isRequired,
    presets_activate_action: PropTypes.string.isRequired,
  }).isRequired,
};

PresetsScreen.defaultProps = {
  goTo: () => {},
};